import { isE2E } from './utils';

(function () {
  const targetEnvironment = import.meta.env.VITE_TARGET_ENV;
  const shouldLoadE2EConfig = isE2E() || targetEnvironment === 'e2e';

  if (shouldLoadE2EConfig) {
    const script = document.createElement('script');
    script.src = '/c_e2e.js';
    document.body.appendChild(script);
  } else {
    const script = document.createElement('script');
    script.src = '/c.js';
    document.body.appendChild(script);
  }
})();
